import { inject, Injectable } from '@angular/core';
import {
  ComparePlanRequest,
  ComparePlanResponse,
} from '../interfaces/business-reserve-compare.model';
import { ApiResponse } from '../interfaces/api-response.model';
import { API_ENDPOINTS } from '../constants/api.constants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CheckSuggestionsEnterpriseRequest, CheckSuggestionsEnterpriseResponse } from '../interfaces/dialogs/business-reserve-add.model';

/**
 * 企業方案比較服務
 */
@Injectable({
  providedIn: 'root',
})
export class BusinessReserveAddService {
  http: HttpClient = inject(HttpClient);

  /**
   * 企業方案比較 CB-034
   * @param request 企業方案加選推薦項目
   */
  getBusinessAddSuggestion(
    request: CheckSuggestionsEnterpriseRequest
  ): Observable<ApiResponse<CheckSuggestionsEnterpriseResponse>> {
    return this.http.post<ApiResponse<CheckSuggestionsEnterpriseResponse>>(
      API_ENDPOINTS.CHECK_SUGGESTIONS_ENTERPRISE,
      request
    );
  }

}
